import React, { useEffect, useState } from "react";
import iconCompany from "../../img/companyIcon.svg";
import Header from "../Header/Header";
import CargoCase from "../CargoCase/CargoCase";
import Man from "../Man/Man";
import Bol from "../Bol/Bol";
import Notifications from "../Notifications/Notifications";
import Database from "../Database/Database";
import ProfileUser from "../ProfileUser/ProfileUser";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import {
  BOL_GET_LIST, CARGO_CASE_GET_LIST,
  CARGO_CASE_POST_LIST,
  MANIFEST_GET_LIST,
  NOTIFICATION_GET_LIST,
} from "../../Api/axios";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import { axiosGetRequest } from "../../Api/axiosGetRequest";
import { axiosGetNotifications } from "../../Api/ApiNotifications/axiosGetNotifications";
import WebSmartContractEthers from "../WebSmartContract/WebSmartContractEthers";

const MainPage = () => {
  const [activeSideBarItem, setActiveSideBarItem] = useState("CargoCase");
  const [activeProfileModal, setActiveProfileModal] = useState(false);
  const [getListCargoCase, setGetListCargoCase] = useState([]);
  const [getListMan, setGetListMan] = useState([]);
  const [getListBol, setGetListBol] = useState([]);
  const [getListNotifications, setGetListNotifications] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const { stateReducer, setNameDocHeader, auth } = useAuth();

  const sidebarItems = [
    { namedItem: "CargoCase" },
    { namedItem: "MAN" },
    { namedItem: "BOL" },
    { namedItem: "Notifications" },
  ];

  function onHandleSidebarItem(nameItem) {
    if (activeSideBarItem === nameItem) {
      return nameItem;
    } else {
      setActiveSideBarItem(nameItem);
      setNameDocHeader("");
    }
  }

  function onHandleOpenProfileUser() {
    setActiveSideBarItem("Profile");
    setNameDocHeader("");
    setActiveProfileModal(false);
  }

  useEffect(() => {
    let isLoading = true;
    const controller = new AbortController();

    if (activeSideBarItem === "CargoCase") {
      const postCargoCaseList = async () => {
        try {
          const response = await axiosPrivate.get(
              CARGO_CASE_GET_LIST)
          //   JSON.stringify({
          //     key: "shipperName",
          //     operation: "MORE",
          //     value: "il_osipov",
          //     joinType: "AND",
          //     complex: true,
          //   }),
          //   {
          //     signal: controller.signal,
          //   }
          // );
          isLoading && setGetListCargoCase(response.data);
        } catch (err) {
          // navigate('/auth', {state: {from: location}, replace: true})
          // logout();
          console.error(err);
        }
      };
      postCargoCaseList();
    } else if (activeSideBarItem === "MAN") {
      axiosGetRequest(
        axiosPrivate,
        MANIFEST_GET_LIST,
        controller,
        isLoading,
        setGetListMan
      );
    } else if (activeSideBarItem === "BOL") {
      axiosGetRequest(
        axiosPrivate,
        BOL_GET_LIST,
        controller,
        isLoading,
        setGetListBol
      );
    } else if (activeSideBarItem === "Notifications") {
      axiosGetNotifications(
        axiosPrivate,
        NOTIFICATION_GET_LIST,
        auth?.user?.id,
        controller,
        isLoading,
        setGetListNotifications
      );
    }
    return () => {
      isLoading = false;
      isLoading && controller.abort();
    };
  }, [activeSideBarItem, stateReducer.request, stateReducer.toggleBackPage]);

  useEffect(() => {
    let isLoading = true;
    const controller = new AbortController();
    axiosGetNotifications(
      axiosPrivate,
      NOTIFICATION_GET_LIST,
      auth?.user?.id,
      controller,
      isLoading,
      setGetListNotifications
    );

    return () => {
      isLoading = false;
      isLoading && controller.abort();
    };
  }, []);

  return (
    <div className="main-page__container">
      <div className="main-page-header">
        <Header
          sidebarName={activeSideBarItem}
          onHandleOpenProfileUser={onHandleOpenProfileUser}
          activeProfileModal={activeProfileModal}
          setActiveProfileModal={setActiveProfileModal}
          getListNotifications={getListNotifications}
        />
      </div>
      <div className="main-page-sidebar">
        <div className="main-page-sidebar__name-company-icon">
          <img
            src={iconCompany}
            className="main-page-sidebar__icon-company"
            alt={"иконка с эмблемой компании"}
          />
          <p className="main-page-sidebar__name-company">
            {auth.user?.organization?.name ?? "No organization"}
          </p>
        </div>
        <div className="main-page-sidebar-menu-list">
          {sidebarItems.map((el, i) => {
            return (
              <div
                onClick={() => onHandleSidebarItem(el.namedItem)}
                key={i}
                className={
                  activeSideBarItem === el.namedItem
                    ? "main-page-sidebar-menu-list__menu-item active"
                    : "main-page-sidebar-menu-list__menu-item"
                }
              >
                <p className="main-page-sidebar-menu-list__name-item">
                  {el.namedItem}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="main-page-content">
        <>
          {activeSideBarItem === "CargoCase" && (
            <CargoCase getListCargoCase={getListCargoCase} setGetListCargoCase={setGetListCargoCase}
            />
          )}
          {activeSideBarItem === "MAN" && <Man getListMan={getListMan} />}
          {activeSideBarItem === "BOL" && <Bol getListBol={getListBol} />}
          {activeSideBarItem === "Notifications" && (
            <Notifications getListNotifications={getListNotifications} />
          )}
          {activeSideBarItem === "Database" && <Database />}
          {activeSideBarItem === "WebSmartContract" && (
            <WebSmartContractEthers />
          )}
          {activeSideBarItem === "Profile" && <ProfileUser />}
        </>
      </div>
    </div>
  );
};
export default MainPage;
